module.exports = __webpack_public_path__ + "media/images/users_voice011-c1631366e88478cbf3d52da2e9b158cc.jpg";